export const plug = () => (
  <path
    d="M10.022 14.34a7.222 7.222 0 0010.213 0l1.702-1.702L11.724 2.426l-1.702 1.702a7.221 7.221 0 000 10.212zm0 0l-1.509 1.51a1.805 1.805 0 01-2.553 0l-.116-.117a1.641 1.641 0 10-2.321 2.321l.116.116a1.805 1.805 0 010 2.553L2.362 22m17.022-11.915l2.978-2.979M14.277 4.98L17.257 2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
